const FILE_TYPES = [
    { value: 'rail_profile', label: 'Rail Profile', type: 'ban' },
    { value: 'wheel_profile', label: 'Wheel Profile', type: 'whl' },
    { value: 'has60_profile', label: 'HAS60 Profile', type: 'has60' }
]

export default {
    state: {
        selectedExchangeId: null,
        customerExchanges: [],
        exchangeFileType: null,
        railRequiredIDs: ['scac','line','track','mile','side'],
        wheelRequiredIDs: ['scac','wpd_id','car_id','side','axel_number'],
    },
    mutations: {
        setCustomerExchanges(state, customerExchanges) {
            if(customerExchanges) {
                state.customerExchanges = customerExchanges
            }
            else {
                state.customerExchanges = [];
            }
        },
        setFileType(state, fileType) {
            state.exchangeFileType = fileType
        },
        setSelectedExchangeId(state, exchangeId) {
            state.selectedExchangeId = exchangeId
        }
    },
    getters: {
        getCustomerExchanges: state => {
            return state.customerExchanges
        },
        getFileType: state => {
            return state.exchangeFileType
        },
        getRailRequiredIDs: state => {
            return state.railRequiredIDs
        },
        getWheelRequiredIDs: state => {
            return state.wheelRequiredIDs
        },
        getExchangeId: state => {
            return state.selectedExchangeId
        },
        getFileTypes: state => {
            return FILE_TYPES
        },
        getRequiredIdsFormatted: state => {
            if(state.exchangeFileType) {
                if(state.exchangeFileType === 'rail_profile') {
                    const formatted = state.railRequiredIDs.map(val => val.toUpperCase()).join(', ');
                    return formatted
                }
                else if(state.exchangeFileType === 'wheel_profile') {
                    const formatted = state.wheelRequiredIDs.map(val => val.toUpperCase()).join(', ');
                    return formatted
                }
            }
            return 'NO REQUIRED IDS'
        }
    },
    actions: {
        /* Set Globals */
        setExchangeId(context, exchangeId) {
            context.commit('setSelectedExchangeId', exchangeId)
        },
        /**
         * POST
         *  exchangeId String Unique Identifier for this upload
         *  digitalTwinId String Unique Identifier for the LORAM VR Platform asset this data is for
         *  dataType String Data type (ex Rail Profile)
         *  fileNames String List of files included in this upload
         * 
         * @returns {Object} { defaults {Array}, scenarios {Array} }
         */
        async createNewDataExchange(context, payload) {
            const requiredProps = ['platformMetadata','dataType','fileNames','exchangeName']
            if (requiredProps.every(prop => prop in payload)) {
                const {platformMetadata, dataType, fileNames, exchangeName, dataSource} = payload;
                try {
                    const api = context.rootState.exchangeService.exchangeApi;
                    const {data = {}} = await api.post(`/exchange/`,
                        {platformMetadata, fileNames, dataType, dataSource, exchangeName}
                    );
                    return data;
                }
                catch(err) {
                    console.log('Data Infrastructure API Error: Failed createNewDataExchange', err);
                    throw new Error(err);
                }
            }
            else {
                console.log('Data Infrastructure Error: Missing required parameters.');
            }
        },
        /**
         * POST
         *  fileId Unique ID pre signed URL gave the file
         *  fileName Name of file that was uploaded
         * 
         * @returns {Object} { defaults {Array}, scenarios {Array} }
         */
        async createNewExchangeFile(context, payload) {
            const requiredProps = ['exchangeId', 'fileId', 'fileName']
            if (requiredProps.every(prop => prop in payload)) {
                const {exchangeId, fileId, fileName} = payload;
                try {
                    const api = context.rootState.exchangeService.exchangeApi;
                    const {data = {}} = await api.post(`/exchange/${exchangeId}/file`,
                        {fileId, fileName}
                    );
                    return data;
                }
                catch(err) {
                    console.log('Data Infrastructure API Error: Failed createNewExchangeFile', err);
                    throw new Error(err);
                }
            }
            else {
                console.log('Data Infrastructure Error: Missing required parameters.');
            }
        },
        /**
         * GET
         *  dataId Unique Identifier of the owner of the data
         * 
         * @returns {Object} { defaults {Array}, scenarios {Array} }
         */
        async getExchanges(context) {
            try {
                const api = context.rootState.exchangeService.exchangeApi;
                const customerId = context.rootGetters.getCurrentCustomerId;
                const {data = {}} = await api.get(`/exchange/${customerId}/`);
                context.commit('setCustomerExchanges', data);
            }
            catch(err) {
                console.log('Data Infrastructure API Error: Failed getExchanges', err);
                throw new Error(err);
            }
        },
        async setActiveFileType(context, fileType) {
            context.commit('setFileType', fileType)
        }
    }
} 
